export default "__VITE_ASSET__dd8e601d__"